import React from 'react'

type DataTableContextType = {
  /**
   * @default false
   * If false index will not be passed to cell renderers, useful for high frequency lists to avoid re-rendering
   */
  disableIndex: boolean
}

export const DataTableContext = React.createContext<DataTableContextType>({
  disableIndex: false,
})
